import './loading.css'

export function LoadingRectangles(){
    return(<div className="lds-facebook"><div></div><div></div><div></div></div>)
}
export function LoadingCircles(){
    return <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
}